import React from "react";
import { Navbar } from "@allxsmith/bestax-bulma";
import {Link} from "react-router-dom";

export default function InvoiceNav({setMenuActive}){

    return (
        <Navbar.DropdownMenu>
            <Navbar.Item>
                <Link to={"/invoicing"}>
                    Workshop Invoicing
                </Link>
            </Navbar.Item>
            <Navbar.Item>
                <Link to={"/invoices?activeView=movement"}>
                    Movement Invoicing
                </Link>
            </Navbar.Item>
            <Navbar.Item>
              <Link to={"/invoices?activeView=sales"}>
                  Vehicle Sales Invoicing
              </Link>
            </Navbar.Item>
            <Navbar.Item>
                <Link to={"/invoices?activeView=order"}>
                    Parts Invoicing
                </Link>
            </Navbar.Item>
            <Navbar.Item>
                <Link to={"/invoices?activeView=hire"}>
                    Hire Invoicing
                </Link>
            </Navbar.Item>
        </Navbar.DropdownMenu>
    );
}